module.exports = __webpack_public_path__ + "img/juventus.bbd7e709.png";